module.exports = __webpack_public_path__ + "img/promo.28625c8e.svg";